import ProductCollectionPage from "../common/ProductCollectionPage";

const Newarrivals = ({ onAddToCart }) => (
  <ProductCollectionPage
    seo={{
      title: "New Arrivals",
      description: "The latest additions to the Emporia collection — fresh arrivals in fashion, electronics, and more.",
      path: "/new-arrivals",
    }}
    query="tag=New"
    heading="New Arrivals"
    tagline="The latest additions, fresh this week."
    suppressNewBadge={true}
    onAddToCart={onAddToCart}
  />
);

export default Newarrivals;
